import { GlobalContext } from "components/GlobalContext";
import { useContext, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { ReactQrCode } from '@devmehq/react-qr-code';
import { printElement } from "utilities/BrowserUtility";
import html2canvas from 'html2canvas';

const QRCodeGenerator = () => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;
    const [url, setUrl] = useState("");
    const ref = useRef<HTMLDivElement>(null)

    return (
        <>
            <Row>
                <Col>
                    <Form.Group className="mb-3" >
                        <Form.Label>URL</Form.Label>
                        {
                            <Form.Control
                                type="text"
                                onChange={
                                    (e: React.ChangeEvent<HTMLInputElement>) => {
                                        setUrl(e.target.value);
                                    }
                                }
                                value={url}
                            />
                        }
                    </Form.Group>
                </Col>
            </Row>
            {
                url &&
                <Row>
                    <Col>
                        <Button
                            style={{ width: "100%", height: "130px" }}
                            onClick={() => {
                                const el = document.getElementById(`qrcode`);
                                printElement(el);
                            }}>Print</Button><br /><br />
                        <Button
                            style={{ width: "100%", height: "130px" }}
                            onClick={async () => {
                                if (ref.current === null) {
                                    return
                                }

                                const fileName = window.prompt('Image file name?', "QRCode") || 'QRCode.jpg';
                                const element = ref.current;
                                const canvas = await html2canvas(element);

                                const data = canvas.toDataURL('image/jpg');
                                const link = document.createElement('a');

                                if (typeof link.download === 'string') {
                                    link.href = data;
                                    link.download = fileName;

                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                } else {
                                    window.open(data);
                                }
                            }}>Export JPG</Button>
                    </Col>
                    <Col>
                        <div
                            style={{ width: "290px", height: "290px" }}
                            ref={ref}
                            className="print-qr-code p-3 text-center"
                            id="qrcode" >
                            <ReactQrCode
                                value={url}
                                renderAs="canvas"
                            />
                        </div>
                    </Col>
                </Row>
            }
        </>
    );
}

export default QRCodeGenerator;